import React, { useState } from "react";
import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

const menuItemSx = {
  py: 0.5,
  px: 1.25,
  minHeight: 32,
  gap: 0.5,
};

const iconSx = { minWidth: 28, color: "inherit" };

const VehicleActionsMenu = ({
  vehicle,
  translate,
  onViewMulkiya,
  onDownloadMulkiyaPdf,
  onViewAssessment,
  onDelete,
  onSyncServers,
  onVehicleHistory,
  onVehicleDns,
  hasAccessOfDelete,
  hasAccessOfVehicleSendData,
  showVehicleHistory,
  showVehicleDns,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const run = (fn) => (e) => {
    e?.stopPropagation?.();
    handleClose();
    fn?.(vehicle);
  };

  return (
    <>
      <Tooltip title={translate?.("actions") || "Actions"} enterDelay={300}>
        <IconButton onClick={handleClick} size="small" sx={{ p: 0.5 }}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        dense
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClick={(e) => e.stopPropagation()}
        MenuListProps={{ dense: true, sx: { py: 0.5 } }}
        PaperProps={{ sx: { minWidth: 180 } }}
      >
        <MenuItem onClick={run(onViewMulkiya)} sx={menuItemSx}>
          <ListItemIcon sx={iconSx}>
            <BadgeOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={translate?.("viewMulkiya") || "View Mulkiya"}
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        <MenuItem onClick={run(onViewAssessment)} sx={menuItemSx}>
          <ListItemIcon sx={iconSx}>
            <AssignmentOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={translate?.("viewAssessment") || "View Assessment"}
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        {(showVehicleHistory ||
          showVehicleDns ||
          hasAccessOfVehicleSendData) && (
          <Divider sx={{ my: 0.5 }} />
        )}

        {showVehicleHistory ? (
          <MenuItem onClick={run(onVehicleHistory)} sx={menuItemSx}>
            <ListItemIcon sx={iconSx}>
              <HistoryOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={translate?.("ownershipHistory") || "Ownership History"}
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        ) : null}

        {showVehicleDns ? (
          <MenuItem onClick={run(onVehicleDns)} sx={menuItemSx}>
            <ListItemIcon sx={iconSx}>
              <LocalShippingOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={translate?.("vehicleDn's") || "Vehicle DNs"}
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        ) : null}

        {hasAccessOfVehicleSendData ? (
          <MenuItem onClick={run(onSyncServers)} sx={menuItemSx}>
            <ListItemIcon sx={iconSx}>
              <SyncOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={translate?.("syncServers") || "Sync Servers"}
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        ) : null}

        {hasAccessOfDelete ? (
          <>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={run(onDelete)} sx={menuItemSx}>
              <ListItemIcon sx={iconSx}>
                <DeleteOutlineIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={translate?.("delete") || "Delete"}
                primaryTypographyProps={{ variant: "body2" }}
              />
            </MenuItem>
          </>
        ) : null}
      </Menu>
    </>
  );
};

export default VehicleActionsMenu;
